import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { FadeLoader } from "react-spinners";
import AppointmentScheduleModal from "../modals/AppointmentScheduleModal";
import socket from "../../../../context/socket";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { getMeetingPR } from "../../../../utils/getMeetingPr";
import api from "../../../../utils/api";

export const TabOne = ({
  setSelectedCards,
  selectedCards,
  selectedTab,
  setSelectedTab,
  roomId,
  clientData,
  setPrsuggections,
  isPortfolioData,
  searchParamsPRFail
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [cardsData, setCardsData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [prsteps_selected, setPrstepsSelected] = useState([]); // New state for selected cards
  console.log("prsteps_selected", prsteps_selected);


  useEffect(() => {
    const initialCards = [
      {
        id: "1",
        title: "Return Led Risk Reduction",
        description: `When Equity Markets have given extraordinary returns over a relatively short timeframe, and your portfolio returns have gone significantly past the long term returns that can be expected from aggressive funds.`,
        image: "/assets/images/33.svg",
      },
      {
        id: "2",
        title: "Periodic Rebalancing",
        description: `Typically, once every 12 months regardless of how markets are poised. Even “No Action Required” is an action! Think of it as a preventive health check that helps keep your portfolio in good health and neatly aligned with your goals.`,
        image: "/assets/images/32.svg",
      },
      {
        id: "3",
        title: "Life Event Based Review",
        description: `Whenever any material impact in your life has changed your risk appetite, it warrants a portfolio review. Examples include: a loss of income, an addition in the family, medical issues, or nearing your retirement.`,
        image: "/assets/images/31.svg",
      },
    ];
    setCardsData(initialCards);
    setLoading(false);
  }, []);



  useEffect(() => {
    if (isPortfolioData?.prinfo?.why_pr && prsteps_selected.length === 0) {
      const val = isPortfolioData?.prinfo?.why_pr;

      // console.log("val", val);

      const formattedVal = typeof val === "string" ? val.split(",").map(String) : Array.isArray(val) ? val.map(String) : [];

      setPrstepsSelected(formattedVal);
    }
  }, [isPortfolioData]);

  const handleCardClick = (cardId) => {
    setPrstepsSelected((prevSelected) => {
      const selectedArray = Array.isArray(prevSelected) ? prevSelected : [];
      if (selectedArray.includes(cardId)) {
        // Unselect if already selected
        return selectedArray.filter((id) => id !== cardId);
      } else {
        // Select the card
        return [...selectedArray, cardId];
      }
    });
  };


  const getCardClass = (cardId) =>
    prsteps_selected.includes(cardId) ? "activeCard" : "";


  const updateClientPRData = async (payload) => {
    return api.post(`advisor/updateprdataWM`, payload);
  };

  const updateClientPRDataStep2 = async (payload) => {
    return api.post(`advisor/updateprdataWM`, payload);
  };
  const handleNext = async () => {

    const reviewedFolio = isPortfolioData?.clientreviewedfolio || [];

    const allNoAction = reviewedFolio.length > 0 && reviewedFolio.every(
      item => item.recommended_action === "<span class='remarkmsg'>No Action required.</span>"
    );


    const prid = searchParamsPRFail||isPortfolioData?.prinfo?.portfolio_review_id
    const resMeeting = await getMeetingPR(roomId,prid );

    const meetingStatus = resMeeting.data.meetingExists;

    // console.log('meetingStatus',meetingStatus)
    // if (reviewedFolio.length === 0 || allNoAction || !meetingStatus) {
    //   setShowModal(true);
    //   return;
    // }

    if (!meetingStatus) {
      setShowModal(true);
      return;
    }

    try {
      const { portfolio_review_id } = isPortfolioData.prinfo || {};
      const payloadBase = {
        clientid: roomId,
        pr_id: portfolio_review_id,
        prsteps_selected,
        action: "whyReblance",
        toggle_: 0,
      };

      const payload2 = {
        ...payloadBase,
        step: 51,
      };

      const payload3 = {
        ...payloadBase,
        step: 52,
      };

      const response2 = await updateClientPRData(payload2);
      const response3 = await updateClientPRDataStep2(payload3);

      // console.log("payload3", payload3);
      // console.log("response3", response3?.data);

      setPrsuggections(response3?.data?.prsuggections);
//////////////////////////////////////////////////////////////////// 13-03-26 for newly selected cards instead of old API data
       if (isPortfolioData?.prinfo) {
      isPortfolioData.prinfo.why_pr = prsteps_selected;
    }
//////////////////////////////////////////////////////////////
      if (selectedTab < 4) {
        setSelectedTab(prev => prev + 1);
      }
    } catch (error) {
      console.error("Error during API calls:", error);
    }
  };





  const handleBack = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    let prevUrl;
    let prevUrl2;
    if (clientData?.kyc_info?.is_kyc_done === 'yes') {
      prevUrl = `/my-investment?clientId=${roomId}`;
      prevUrl2 = `/my-investment`;

    } else {
      prevUrl = `/address-proof?clientId=${roomId}`;
      prevUrl2 = `/address-proof`;

    }

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const handleRetry = () => {
    // Logic for retrying API fetch
  };



  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const sendDataToServer = useCallback(
    debounce((data) => {
      socket.emit("message_to", { room: roomId, data: { prsteps_selected } });
      // console.log("Emiting Message_to :",prsteps_selected);

    }, 500),
    [roomId, prsteps_selected]
  );

  useEffect(() => {
    sendDataToServer({ prsteps_selected });
  }, [sendDataToServer, prsteps_selected]);

  return (
    <>
      <AppointmentScheduleModal
        show={showModal}
        onHide={() => setShowModal(false)}
        roomId={roomId}
        setPrsuggections={setPrsuggections}
        isPortfolioData={isPortfolioData}
        clientData={clientData}
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
        prsteps_selected={prsteps_selected}
      />
      <div className="container" style={{ minHeight: "500px" }}>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <FadeLoader color="#23674B" size={50} />
          </div>
        ) : apiError ? (
          <div className="text-center">
            <p className="text-danger">
              Failed to load portfolio data. Please try again.
            </p>
            <button className="lrgbutton text-white" onClick={handleRetry}>
              Retry
            </button>
          </div>
        ) : (
          <>
            <div className="row">
              <h2>Portfolio Review: Why?</h2>
            </div>
            <div className="row mt-0 mt-md-3 row-cols-lg-3 row-cols-md-2 row-cols-1 pt-1 pt-md-3 mb-2 mb-md-5">
              {cardsData.map((card) => (
                <div className="col mb-3 mb-md-4 " key={card.id}>
                  <div
                    className={`card   ${prsteps_selected.includes(card.id)
                      ? "border-5 border-green-500 py-4 py-md-4"
                      : "border border-gray-300 py-4 py-md-4"
                      } ${getCardClass(card.id)}`}
                    style={{
                      height: "100%",
                      cursor: "pointer",
                      borderColor: prsteps_selected.includes(card.id)
                        ? " #87C100"
                        : " #ccc",
                      borderRadius: "10px",
                      // transition: "all 0.3s ease",
                    }}
                    onClick={() => handleCardClick(card.id)}
                  >
                    <img
                      src={card.image}
                      className="card-img-top mb-0 mb-md-3"
                      alt={card.title}
                      style={{ maxHeight: "150px", objectFit: "contain" }}
                    />
                    <div className="card-body mb-0">
                      <h5 className="fs-4">{card.title}</h5>
                      <p className="card-text fs-18">{card.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Buttons */}
            <div className="container">
              <div className="row">
                <div className="col text-end">
                  <a href="javascript:void(0);" onClick={handleBack}>
                    <img
                      className="arrow_next1"
                      src="/assets/images/left-arrowpng.png"
                      alt=""
                    />
                  </a>
                  <a
                    href="javascript:void(0);"
                    className="ms-1"
                    onClick={handleNext}
                    disabled={selectedTab === 4}
                  >
                    <img
                      className="arrow_next"
                      src="/assets/images/right-arrow.svg"
                      alt="Next"
                    />
                  </a>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
